import { Box } from "@primer/react";
import DataGrid from "../../components/ui/data-grid";
import { IDataGridColumn } from "../../components/ui/data-grid/type/IDataGridProps";
import { useMemo } from "react";
import { ArrowLeftIcon, PlusIcon, SyncIcon } from "@primer/octicons-react";
import Button from "../../components/ui/button";


type Subject = {
    id: number;
    name: string;
    sis_giaovien_id: number;
};

interface Props {
    hocSinhs: any[];
    subjects: Subject[];
    assigns: any[];
    setAssigns: (fn: (prev: any[]) => any[]) => void;
}

const AssignTeacherGrid = ({
    hocSinhs,
    subjects,
    assigns,
    setAssigns
}: Props) => {

    // =========================
    // CHECK ASSIGNED
    // =========================
    const isAssigned = (hsId: number, subjectId: number) => {
        return assigns?.some(a =>
            a.ts_hocsinh_id === hsId &&
            a.sis_lop_monhoc_id === subjectId
        );
    };

    // =========================
    // TOGGLE
    // =========================
    const toggleAssign = (hs: any, subject: Subject) => {
        setAssigns(prev => {
            const exists = prev?.find(a =>
                a.ts_hocsinh_id === hs.id &&
                a.sis_lop_monhoc_id === subject.id
            );

            if (exists) {
                return prev.filter(a =>
                    !(a.ts_hocsinh_id === hs.id && a.sis_lop_monhoc_id === subject.id)
                );
            }

            return [
                ...prev,
                {
                    id: 0,
                    sis_giaovien_id: subject.sis_giaovien_id,
                    sis_lop_monhoc_id: subject.id,
                    ts_hocsinh_id: hs.id
                }
            ];
        });
    };

    // =========================
    // DATASOURCE
    // =========================
    const dataSource = useMemo(() => {
        return hocSinhs.map(hs => ({
            ...hs
        }));
    }, [hocSinhs]);

    // =========================
    // COLUMNS
    // =========================
    const columns: IDataGridColumn[] = useMemo(() => {
        return [
            {
                dataField: "ma_hs",
                caption: "Mã học sinh",
                width: 150,
                fixed: "left"
            },
            {
                dataField: "ho_ten",
                caption: "Họ tên",
                width: 200,
                fixed: "left"
            },
            ...subjects.map(subject => ({
                dataField: `sub_${subject.id}`,
                caption: subject.name,
                width: 140,
                align: "center" as const,
                cellRender: (row: any) => {
                    const checked = isAssigned(row.id, subject.id);

                    return (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%"
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => toggleAssign(row, subject)}
                            /> 
                        </Box>
                    );
                }
            }))
        ];
    }, [subjects, assigns]);

    return (
        <DataGrid
            columns={columns}
            dataSource={dataSource}
            searchEnable={true}
        />
    );
};

export default AssignTeacherGrid;